import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeCtx = createContext();

export function ThemeProvider({ children }) {
  const [light, setLight] = useState(() => {
    const saved = localStorage.getItem('apnaa_theme');
    return saved ? saved === 'light' : true; // default dark
  });

  useEffect(() => {
    localStorage.setItem('apnaa_theme', light ? 'light' : 'dark');
    document.documentElement.setAttribute('data-theme', light ? 'light' : 'dark');
  }, [light]);

  return (
    <ThemeCtx.Provider value={{ light, toggle: () => setLight(d => !d) }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
